import styled from "styled-components";

export const StyledTech = styled.li`
  background-color: var(--color-gray-4);
  border-radius: 4px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  width: 100%;
  height: 3.5rem;

  &:hover {
    background-color: var(--color-gray-2);
  }

  h3 {
    font-weight: 700;
    font-size: 14.21px;
    line-height: 22px;
    color: #fff;
  }

  span {
    color: var(--color-gray-1);
    font-weight: 400;
    font-size: 12.182px;
    line-height: 22px;
  }

  div {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 1.2rem;
  }

  button {
    background-color: transparent;
    border: none;
  }

  svg {
    font-size: 13px;
    color: var(--color-gray-1);
  }
`;
